import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["selected", "productLevel", "disabled", "onClick", "isCurrentPlan", "price"];
let _ = t => t,
  _t;
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled, { css } from 'styled-components';
import UISelectableBox from 'UIComponents/button/UISelectableBox';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import Small from 'UIComponents/elements/Small';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import PriceDisplay from '../../common/pricing/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectableBox = styled(UISelectableBox).withConfig({
  displayName: "ProductLevelSelectionButton__SelectableBox",
  componentId: "sc-1cnkydn-0"
})(["&&&{width:100%;border-radius:0;&:hover{z-index:8;}", ";", ";}"], ({
  disabled
}) => disabled && css(["border-color:", " !important;font-weight:400;"], GREAT_WHITE), ({
  selected
}) => selected && css(["background-color:inherit;z-index:7;"]));
const StyledProductLevel = styled.span.withConfig({
  displayName: "ProductLevelSelectionButton__StyledProductLevel",
  componentId: "sc-1cnkydn-1"
})(["font-weight:500;font-size:14px;"]);
const SelectionButtonWrapper = styled.div.withConfig({
  displayName: "ProductLevelSelectionButton__SelectionButtonWrapper",
  componentId: "sc-1cnkydn-2"
})(["width:33.333333%;width:calc(100% / 3);margin:0 5px;", ";&:first-child{margin-left:0;}&:last-child{margin-right:0;}"], breakpoint.phone(_t || (_t = _`
    display: block;
    width: 100%;
    margin: 0;
  `)));
const CurrentPlanText = styled.span.withConfig({
  displayName: "ProductLevelSelectionButton__CurrentPlanText",
  componentId: "sc-1cnkydn-3"
})(["font-weight:600;"]);
const ButtonContents = styled(UIFlex).withConfig({
  displayName: "ProductLevelSelectionButton__ButtonContents",
  componentId: "sc-1cnkydn-4"
})(["height:36px;line-height:18px;margin:16px 0;padding-left:12px;"]);
const ProductLevelSelectionButton = _ref => {
  let {
      selected,
      productLevel,
      disabled,
      onClick,
      isCurrentPlan,
      price
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsx(SelectionButtonWrapper, {
    children: /*#__PURE__*/_jsx(SelectableBox, Object.assign({
      flush: true,
      type: "checkbox",
      selectionMarkLocation: "top-right",
      onClick: onClick,
      selected: selected,
      disabled: disabled,
      "data-selenium-class": `${productLevel}-product-level-button`,
      "data-selected": selected,
      "data-disabled": disabled,
      "data-current-plan": isCurrentPlan
    }, rest, {
      children: /*#__PURE__*/_jsxs(ButtonContents, {
        direction: "column",
        align: "start",
        justify: "center",
        children: [/*#__PURE__*/_jsx(StyledProductLevel, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            className: "bold",
            message: `planBuilder.productLevel.${productLevel}`
          })
        }), /*#__PURE__*/_jsx(Small, {
          children: isCurrentPlan ? /*#__PURE__*/_jsx(CurrentPlanText, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "planBuilder.currentPlanParentheses"
            })
          }) : /*#__PURE__*/_jsx("div", {
            style: {
              fontWeight: 600
            },
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "planBuilder.priceDisplay.pricePerMonth",
              options: {
                price: /*#__PURE__*/_jsx(PriceDisplay, {
                  price: price,
                  currencyCode: currencyCode
                })
              }
            })
          })
        })]
      })
    }))
  });
};
export default ProductLevelSelectionButton;